import { render, staticRenderFns } from "./InstagramCard.vue?vue&type=template&id=5a2113e2&scoped=true&"
import script from "./InstagramCard.vue?vue&type=script&lang=js&"
export * from "./InstagramCard.vue?vue&type=script&lang=js&"
import style0 from "./InstagramCard.vue?vue&type=style&index=0&id=5a2113e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2113e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/prpatel/dev/connectevents/twitter-image-generator/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VFlex})
